import React from 'react';
import { useAuth } from '../../context/AuthContext';
import MainLayout from '../MainLayout/MainLayout';
import AdminLayout from '../AdminLayout/AdminLayout';

// Renders the sidebar layout for logged-in candidates and the
// public header/footer layout for everyone else.
const RoleLayout = () => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user?.role === 'candidate') {
    return <AdminLayout />;
  }

  return <MainLayout />;
};

export default RoleLayout;
